import SignupService from "./services/ZdashService";

const SIGNUP_ID_KEY = "signup.uuid";

// TODO: Catch errors and 404
const store = {
  signup: undefined,
  signupId: undefined,
  signupService: SignupService,

  clear() {
    this.signup = undefined;
    this.signupId = undefined;
  },
  async load() {
    if (this.signupId) {
      const signup = new SignupService();
      try {
        this.signup = await signup.get(this.signupId);
      } catch (e) {
        if (e.response && e.response.status === 404) {
          this.clear();
        }
      }
    }
  },
  async _saveSignup(data) {
    this.signup = await this.signupService.save(data);
    this.signupId = this.signup.uuid;
  },
  async save_signup(data) {
    if (!this.signupId) {
      await this._saveSignup(data);
    } else {
      // Try to update, if it doesn't exist - create new one
      try {
        this.signup = await this.signupService.update(this.signupId, data);
      } catch (e) {
        if (e.response && e.response.status === 404) {
          await this._saveSignup(data);
        } else {
          throw e;
        }
      }
    }
  },
  async get_cart() {
    if (this.signupId) {
      return await this.signupService.cart(this.signupId);
    }
  },
  async apply_promo(promocode) {
    if (this.signupId) {
      return await this.signupService.promocode(this.signupId, promocode);
    }
  },
};
store.signupService = new SignupService();
export default store;
